import Banner from "../Banner";

const HeroBanner = ({ src, alt }) => {
  return <Banner src={src} alt={alt} />;
};

export default HeroBanner;
